export const removeSpacesAfterLastWord = (str) => {
  return str.replace(/\s+$/, "");
};
